<template>
  <!-- component container -->
  <div class="donut" :class="classDonut">
    <h2>{{val}}{{units}}</h2>
    <svg>
     <g>
      <title>Layer 1</title>
      <circle r="69.85699" cy="81" cx="81" class="circle_animation" fill="none"></circle>
     </g>
    </svg>
  </div>
  <!-- component container END -->
</template>

<script>
export default {
  name: 'Donut',
  props: ['val', 'units'],
  data () {
    return {};
  },
  computed: {
    classDonut () {
      var num = this.val;
      var numb = Math.abs(num);
      var numt = (parseInt(numb / 10, 10) + 1) * 10 - 10;
      var clss = '';

      if (num === '0') {
        clss = 'e0';
      } else if (numb < 1) {
        clss = 'e1';
      } else if (numb < 10) {
        clss = 'e' + Math.round(numb);
      } else if (numb > 100) {
        clss = 'e100';
      } else {
        clss = 'e' + numt;
      }
      if (num < 0) {
        clss += ' donutinverse';
      }
      return clss;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Modules/Misc/Donut.vue